module.exports = __webpack_public_path__ + "img/Scroll.c14ed770.svg";